<template>
  <BaseCardV2
    :btn-action="loading.repartitionAdherent || hasCarteRemplie ? null : {
      libelle: 'Voir ma répartition',
      icon: !isAbonneCulturial ? 'mdi-lock' : '',
      hasOtherAtion: true
    }"
    class="pa-2"
    :has-help="hasCarteRemplie"
    titre="Répartition du chiffre d'affaires par culture"
    @otherAction="onClickInformationAbonnement()"
    @on-help="isOpenModalHelp = true"
  >
    <div
      class="mb-2"
    >
      <BaseLoader v-if="loading.repartitionAdherent" />
      <BaseMessageServerError
        v-else-if="erreur.repartitionAdherent"
        class="mx-5 my-2"
      />
      <div v-else-if="!hasCarteRemplie">
        <div
          class="d-flex
        align-center
        flex-column"
          :class="$vuetify.breakpoint.mobile ? 'mt-6' :'mt-16' "
        >
          <img
            src="@/assets/no-cultures.svg"
            alt="no-cultures"
          >
          <div
            class="intro texte-gris-fonce text-align-center mt-2"
            :class="$vuetify.breakpoint.mobile ? 'mb-6' :'mx-16' "
          >
            <span>Retrouvez la répartition de votre chiffre d’affaires par culture de vente</span>
          </div>
        </div>
      </div>

      <template v-else>
        <RepartitionBarHorizontal
          v-model="valueCode"
          class="my-5 mx-3"
          :data="{
            items: items
          }"
          unit="€"
        />
        <div class="bottom">
          <v-divider class="my-6 mx-3" />
          <div class="d-flex justify-space-between mx-3">
            <div class="d-flex flex-column">
              <div class="titre-h4 texte-gris-fonce mb-2">
                CA cultures {{ anneeRecolteSelected }}
              </div>
              <div class="d-flex">
                <span class="titre-h3 secondary--text align-self-center mr-2">{{ chiffreAffairesCulturesEnEuro | roundNumber(0) | splitNumber }} €</span>
                <BaseEvolutionWithInfo
                  v-if="evolutionChiffreAffairesEnPourcentage != null"
                  :evolution-value="evolutionChiffreAffairesEnPourcentage"
                  :values="chiffreAffairesParAnnee"
                  :unite="'€'"
                />
              </div>
            </div>
            <div class="ml-auto">
              <UserIndicatorJauge
                v-if="repartitionChiffreAffairesCulturesGroupe != null || erreur.repartitionGroupe || loading.repartitionGroupe"
                :chargement="loading.repartitionGroupe"
                :data="{
                  value: positionJaugeGroupe(repartitionChiffreAffairesCulturesGroupe?.codePositionDuNumtiers)
                }"
                :unite="'€'"
                :is-parametres-exploitation-incomplet="!isParametresExploitationComplet"
                :data-groupe="repartitionChiffreAffairesCulturesGroupe?.valeurMoyenneDuGroupe"
                :negative-color="repartitionChiffreAffairesCulturesGroupe?.valeurMoyenneDuGroupe && isParametresExploitationComplet ? '#ec6608' : 'grey'"
                :positive-color="repartitionChiffreAffairesCulturesGroupe?.valeurMoyenneDuGroupe && isParametresExploitationComplet ? '#01713c' : 'grey'"
              />
            </div>
          </div>
        </div>
      </template>

      <HelpModal
        v-if="isOpenModalHelp"
        titre="Répartition du chiffre d'affaires par culture"
        :is-open-modal-help="isOpenModalHelp"
        @close="isOpenModalHelp = false"
      >
        <div slot="baseCardHelpContent">
          <div class="texte text-justify texte-gris-fonce pa-4">
            <p>
              Les données indiquées correspondent aux produits de la récolte {{ anneeRecolteSelected }} (prix de vente, co-produits, aides directes, indemnité d'assurance).
            </p>
            <p class="pt-1">
              Cette part peut évoluer tout au long de la campagne de commercialisation selon vos saisies complémentaires dans la carte "Mon prix de vente".
            </p>
            <p class="pt-1">
              Comparez vos données aux années précédentes lorsqu'elles sont disponibles et à un groupe de comparaison (au niveau du compteur).
            </p>
            <p class="pt-1">
              Sur ce compteur, le quart supérieur du groupe est matérialisé en vert, le quart inférieur est lui, en orange. Quant aux valeurs intermédiaires (entre 25 et 75% des valeurs du groupe), elles sont affichées en gris.
            </p>
          </div>
        </div>
      </HelpModal>
      <InformationAbonnementModal
        v-if="isOpenModalAideInformationAbonnement"
        :is-open-modal-information-abonnement="isOpenModalAideInformationAbonnement"
        code-feature="BILAN_ANNUEL"
        texte="Soyez accompagné par un expert pour faire le bilan de vos coûts et résultats de vos grandes cultures."
        titre="Bilan annuel de vos cultures"
        :is-conseiller-pv-affiche="!isAbonneCulturial"
        @close="isOpenModalAideInformationAbonnement = false"
      />
    </div>
  </BaseCardV2>
</template>

<script>
import BaseCardV2 from '@/components/card/base-card-v2.vue'
import BaseEvolutionWithInfo from '@/components/common/base-evolution-with-info.vue'
import BaseLoader from '@/components/common/base-loader.vue'
import BaseMessageServerError from '@/components/common/base-message-server-error.vue'
import HelpModal from '@/components/modal/help-modal.vue'
import InformationAbonnementModal from '@/views/offre-abonnement/components/modal/information-abonnement-modal.vue'
import RepartitionBarHorizontal from '@/components/chart/v2/repartition-bar-horizontal.vue'
import UserIndicatorJauge from '@/components/chart/v2/user-indicator-jauge.vue'
import { mapActions, mapGetters } from 'vuex'
import { reperesParCode } from '@/utils/palette-repartition'
import { isPanneServeur } from '@/utils/requete'

export default {
  name: 'RepartitionChiffreAffairesParCulture',
  components: { BaseCardV2, BaseEvolutionWithInfo, BaseLoader, BaseMessageServerError, HelpModal, InformationAbonnementModal, RepartitionBarHorizontal, UserIndicatorJauge },
  props: {
    codeGraineRs3Selected: {
      type: String,
      default: null
    },
    anneeRecolteSelected: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      isOpenModalHelp: false,
      loading: {
        repartitionAdherent: false,
        repartitionGroupe: false
      },
      erreur: {
        repartitionAdherent: false,
        repartitionGroupe: false
      },
      isOpenModalAideInformationAbonnement: false
    }
  },

  computed: {
    ...mapGetters({
      abonnements: 'adherent/abonnements',
      atelierCultureVerrouillage: 'cloture/atelierCultureVerrouillage',
      codeCultureMiseEnValeur: 'app/codeCultureMiseEnValeur',
      filtresAdherent: 'filtresComparaison/filtresAdherent',
      isParametresExploitationComplet: 'parametresExploitation/isParametresExploitationComplet',
      repartitionChiffreAffairesParCulture: 'cloture/repartitionChiffreAffairesParCulture',
      evolutionChiffreAffaires: 'cloture/evolutionChiffreAffaires',
      repartitionChiffreAffairesCulturesGroupe: 'cloture/repartitionChiffreAffairesCulturesGroupe',
      repartitionGrandesCultures: 'culture/repartitionGrandesCultures'
    }),
    isAbonneCulturial () {
      return this.abonnements.culturialAbonne
    },
    hasClotureVerrouillee () {
      return this.atelierCultureVerrouillage != null && this.atelierCultureVerrouillage.isAtelierVerrouille
    },
    hasCarteRemplie () {
      return this.isAbonneCulturial
        && this.hasClotureVerrouillee
        && this.items.length > 0
    },
    reperesDesGrandesCultures () {
      const cultures = this.repartitionGrandesCultures?.cultures

      return reperesParCode(cultures?.map(culture => culture.codeTypeCulture))
    },
    items () {
      const cultures = this.repartitionChiffreAffairesParCulture?.cultures
      if (cultures == null) {
        return []
      }

      const reperes = this.reperesDesGrandesCultures
      const rangDe = culture => reperes[culture.typeCulture.code]?.rang ?? Number.MAX_SAFE_INTEGER

      return [...cultures]
        .sort((premiere, seconde) => rangDe(premiere) - rangDe(seconde))
        .map(culture => ({
          code: culture.typeCulture.code,
          label: culture.typeCulture.nom,
          value: Math.round(culture.chiffreAffairesEnEuro),
          percentage: culture.partChiffreAffairesEnPourcentage,
          color: reperes[culture.typeCulture.code]?.couleur
        }))
    },
    chiffreAffairesCulturesEnEuro () {
      return this.repartitionChiffreAffairesParCulture?.chiffreAffairesTotalEnEuro
    },
    chiffreAffairesParAnnee () {
      return this.evolutionChiffreAffaires?.chiffreAffaireParAnnee
    },
    evolutionChiffreAffairesEnPourcentage () {
      return this.evolutionChiffreAffaires?.evolutionMontantChiffreAffaireEnPourcentage
    },
    valueCode: {
      get () {
        return this.codeCultureMiseEnValeur
      },
      set (codeTypeCulture) {
        this.mettreEnValeurCulture(codeTypeCulture)
      }
    }
  },
  watch: {
    anneeRecolteSelected () {
      this.loadRepartitionAdherent()
    },
    hasClotureVerrouillee () {
      this.loadRepartitionAdherent()
    },
    isAbonneCulturial () {
      this.loadRepartitionAdherent()
    },
    filtresAdherent () {
      this.loadRepartitionGroupe()
    }
  },
  created () {
    this.loadRepartitionAdherent()
  },
  methods: {
    ...mapActions({
      incrementerAccesSouscriptionAbonnement: 'accesSouscriptionAbonnement/incrementerAccesSouscriptionAbonnement',
      mettreEnValeurCulture: 'app/mettreEnValeurCulture',
      getRepartitionChiffreAffairesParCulture: 'cloture/getRepartitionChiffreAffairesParCulture',
      getEvolutionChiffreAffaires: 'cloture/getEvolutionChiffreAffaires',
      getRepartitionChiffreAffairesCulturesGroupe: 'cloture/getRepartitionChiffreAffairesCulturesGroupe'
    }),
    loadRepartitionAdherent () {
      if (!this.isAbonneCulturial || !this.hasClotureVerrouillee) {
        return
      }

      this.loading.repartitionAdherent = true
      this.erreur.repartitionAdherent = false
      this.getEvolutionChiffreAffaires().catch(() => {})
      this.getRepartitionChiffreAffairesParCulture()
        .then(() => this.loadRepartitionGroupe())
        .catch((erreur) => {
          this.erreur.repartitionAdherent = isPanneServeur(erreur)
        })
        .finally(() => {
          this.loading.repartitionAdherent = false
        })
    },
    loadRepartitionGroupe () {
      if (!this.hasCarteRemplie) {
        return
      }

      this.erreur.repartitionGroupe = false
      this.loading.repartitionGroupe = true
      this.getRepartitionChiffreAffairesCulturesGroupe()
        .catch(erreur => {
          this.erreur.repartitionGroupe = isPanneServeur(erreur)
        })
        .finally(() => {
          this.loading.repartitionGroupe = false
        })
    },
    positionJaugeGroupe (codePosition) {
      let result = null
      switch (codePosition) {
        case 'QUARTILE_SUP':
          result = 'positive'
          break
        case 'QUARTILE_INF':
          result = 'negative'
          break
        case 'MOYENNE':
          result = 'center'
          break
      }
      return result
    },
    onClickInformationAbonnement () {
      this.isOpenModalAideInformationAbonnement = true
      this.incrementerAccesSouscriptionAbonnement('BILAN_ANNUEL')
    }
  }
}

</script>

<style lang="scss" scoped>
.picto-ferme {
  width: 32%;
}
.positif-color {
  color: #dbbd00;
}
.negatif-color {
  color: #ec6608;
}
</style>
